import React, { useState } from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.min.css";

function Answers(props) {
  // const [answersOne, setAnswersOne] = useState();
  // const [answersTwo, setAnswersTwo] = useState();

  return (
    <div className="Answers">
      {/* <h3>Answers</h3> */}
      <h3>{props.answerData}</h3>
      <h3>{props.answerTypeData}</h3>
      {/* {console.log("t.....", props.testData)} */}
      {/* <Card image={data[0].imgSrc} title={data[0].title} /> */}
      <div className="answersHeader">
        <div className="card">
          <div className="card-header">Result</div>
          <div className="card-body">
            <p>{props.resultDescription}</p>
            {/* test filter for rendering text here in a paragraph */}
          </div>
        </div>
      </div>

      <div className="container">
        {/* <div className="row">{data.map(createCard)}</div> */}
        {/* <div className="row justify-content-center">{props.result}</div> */}
        <div className="row">{props.result}</div>
      </div>
    </div>
  );
}

export default Answers;
